class CurrencyConverter extends HTMLElement {
  constructor() {
    super();
    this.currencyMessages = this.querySelectorAll('[data-currency-text]');
    if(this.currencyMessages.length < 1) return;

    this.currencyMessages.forEach(msg => this.updateCurrency(msg));
  }

  updateCurrency(msg) {
    const text = msg.textContent;
    const currencyRate = Number(Shopify.currency.rate);
    const leftBracketIndex = text.indexOf('{');
    const rightBracketIndex = text.indexOf('}');
    const extractedString = text.substring(leftBracketIndex, rightBracketIndex + 1);
    const extractedNumber = Number(text.substring(leftBracketIndex + 1, rightBracketIndex));
    const updatedAmount = Math.ceil(extractedNumber * currencyRate).toFixed(2);
    msg.textContent = text.replace(extractedString, msg.getAttribute('data-currency-symbol') + updatedAmount)
  }
}

customElements.define('currency-converter', CurrencyConverter);

// Landing page full-width fix
(function() {
  function fixFFWrap() {
    var ffWrap = document.querySelector('.ff-wrap');
    if (!ffWrap) return;
    var narrow = ffWrap.closest('.page-width--narrow');
    if (narrow) {
      narrow.classList.remove('page-width--narrow', 'page-width');
      narrow.style.maxWidth = '100%';
      narrow.style.width = '100%';
      narrow.style.padding = '0';
    }
    var editorWrap = ffWrap.closest('.main-page__editor-wrapper');
    if (editorWrap) editorWrap.style.overflow = 'visible';
    var titleEl = document.querySelector('.main-page__title');
    if (titleEl) titleEl.style.display = 'none';
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixFFWrap);
  } else {
    fixFFWrap();
  }
})();

